import React, { Component } from "react";
//import { Line } from "react-chartjs-2";
import { Card, CardHeader, CardBody } from "shards-react";
import { connect } from "react-redux";
import fetchAllAircraftDataAction from "../../lib/fetchAllAircraftData";
import fetchAircraftExtendedData from "../../lib/focusOnAircraft";
import {
  getAllAircraftError,
  getAllAircraftPending,
  getAllAircraft
} from "../../redux/reducers/rootReducer";

//export default class FlightList extends Component {
class FlightList extends Component {
    constructor(props) {
        super(props)
            this.state = {
             containerOpen: false,
        }
    }
    render() {
        const { allAircraft } = this.props;
        const { pilots } = allAircraft;
        var { RETW } = '';
        RETW = '<table width=100% >';
        if ( pilots )
        {
            pilots.forEach((pilot, index) => {
                if ( pilot )
                {
                    RETW += '<tr><td width=30%>' + pilot.callsign + '</td><td>' + pilot.name + '</td></tr>'
                }
            });
        }
        RETW += '</table>' 
        return( <p dangerouslySetInnerHTML={{__html: RETW}} /> );
    }

}

/** Redux Related Functions  **/
  
const mapStateToProps = state => ({
    error: getAllAircraftError(state),
    allAircraft: getAllAircraft(state),
    pending: getAllAircraftPending(state),
    focusedData: state.focusedData,
    focused: state.focused,
    settings: state.settings,
    goToFocused: state.goToFocused
  });
  
  const mapDispatchToProps = {
    fetchAllData: fetchAllAircraftDataAction,
    fetchAircraftExtendedData
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(FlightList);
